import { z } from "zod";

const CharterType = z.enum(["bareboat", "skippered", "crewed"]);
const status = z.enum(["new_booking", "booking_checked", "on_charter", "completed_charter", "booking_cancelled"]);

const Brand = z.enum(["helm", "anchor"]);

export const FiltersFormT = z.object({
  status: z.array(status).or(z.tuple([])).optional(),
  hubspot: z.string().optional(),
  charterStartDateFrom: z.string().or(z.null()).optional(),
  charterStartDateTo: z.string().or(z.null()).optional(),
  charterDateType: z.enum(["is", "after", "between", "before"]).optional(),
  wonStartDateFrom: z.string().or(z.null()).optional(),
  wonStartDateTo: z.string().or(z.null()).optional(),
  wonDateType: z.enum(["is", "after", "between", "before"]).optional(),
  broker: z
    .object({
      firstName: z.string(),
      lastName: z.string(),
      id: z.number(),
      fullName: z.string(),
      email: z.string().optional(),
    })
    .nullable()
    .optional(),
  customer: z
    .object({
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
      fullName: z.string().nullable(),
    })
    .nullable()
    .optional(),
  operator: z.string().optional(),
  country: z.string().optional(),
  charterType: z.array(CharterType).or(z.tuple([])).optional(),
  brand: z.array(Brand).or(z.tuple([])).optional(),
  slug: z.string().optional(),
});

export type FiltersFormT = z.infer<typeof FiltersFormT>;

export const emptyFiltersForm: FiltersFormT = {
  status: [],
  hubspot: "",
  charterStartDateFrom: null,
  charterDateType: undefined,
  charterStartDateTo: null,
  wonStartDateFrom: null,
  wonDateType: undefined,
  wonStartDateTo: null,
  customer: null,
  broker: null,
  operator: "",
  country: "",
  charterType: [],
  slug: "",
  brand: [],
};
